<template>
  <div class="right" v-if="dataLoaded">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <div class="status" v-if="isEditable">
      <h2 v-translate>Povolené privátní rozsahy IP adres</h2>
      <a
          :title="'Přidat IP prefix' | translate"
          :class="['add', 'add_expand', { open: openNewItem }, { btn_inactive: false}]"
          @click.prevent="toggleNewItem()"
          v-translate>Přidat nový rozsah
      </a>
    </div>
    <div :class="['filter', 'expand_content', { open: openNewItem }]">
      <div class="field_left">
        <p>
          <text-input
              id="ipPrefix-name-add"
              v-model="newCidrIp"
              :required="true"
              ref="newcidraddressref"
          >
            <translate class="translate">Rozsah IP adres</translate>
          </text-input>
        </p>
      </div>
      <div class="field_right field_btn">
        <p class="field">
          <input
              type="submit"
              class="btn"
              :value="'Uložit' | translate"
              @click.prevent.stop="addNewItem"
          />
        </p>
      </div>
    </div>
    <table class="vypis vypis_detail">
      <thead class="no_sortable">
      <tr v-if="entities.length > 0">
        <th class="first_data" v-translate>Privátní rozsah</th>
        <th class="no_padding edit"></th>
      </tr>
      </thead>
      <geoblocking-private-ip-row
          v-for="entity in entities"
          :key="entity.id"
          :entity="entity"
          :isEditable="isEditable"
          @deleteEntity="deleteEntity"
          :ref="'geoblockingprivateiprow'+entity.id"
      ></geoblocking-private-ip-row>
      <tr v-if="!entities.length"><td colspan="2" v-translate>Žádné nastavené rozsahy</td></tr>

    </table>
  </div>
</template>

<script>
import listActions from "@/components/mixins/list-actions"
import GeoblockingPrivateIpRow from "./GeoblockingPrivateIpRow.vue";
export default {
  name: "GeoblockingPrivateIpList",
  components: {GeoblockingPrivateIpRow},
  mixins: [listActions],
  props: {
    isEditable: Boolean,
    idOperator: Number,
  },
  data(){
    return {
      moduleName: "geoblockingPrivateIps",
      openNewItem: false,
      newCidrIp: null,
    }
  },
  created(GeoblockingPrivateIpService) {
    this.entityService = GeoblockingPrivateIpService
    this.formFields.id_operator = this.idOperator;
    this.createdInit()
  },
  methods: {
    toggleNewItem() {
      this.emptyMessage();
      this.openNewItem = !this.openNewItem;
      if (this.openNewItem) {
        this.$refs['newcidraddressref'].setForcedInvalid(false);
        this.newCidrIp = null;
      }
    },
    addNewItem() {
      this.entityService.createEntity(
          {
            cidr_address: this.newCidrIp,
            id_operator: this.idOperator})
          .then(() => {
            this.emptyMessage();
            this.setSuccessMessage();
            this.$emit('reload-entity');
            this.toggleNewItem();
            this.getEntities();
          })
          .catch(function (error) {
            this.setErrorMessage(this.processErrorMessage(error));
          }.bind(this));
    },
    processErrorMessage(error){
      return error['validation_errors'][0];
    }
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/GeoblockingPrivateIpList.vue